/* unplugin-vue-components disabled */
import {markRaw} from 'vue'
import TopicTile from '../topic-tile.vue'
import TrackerSegment from './tracker-segment.vue'
import TrackerButtongroup from './tracker-buttongroup.vue'
import TrackerTextarea from './tracker-textarea.vue'
import TrackerDelete from './tracker-delete.vue'
import {COMPANY_ALERTS, TOPIC_SENSITIVITY} from 'consts/tracker'
import $topics from 'stores/topics2'

export default {
  components: {TopicTile, TrackerSegment, TrackerButtongroup, TrackerTextarea, TrackerDelete},
  props: {
    topicId: {type: String, required: true},
    head: {type: Boolean, default: false}
  },
  data() {
    return {
      topic: undefined,
      loading: true,
      saving: false,
      SENSITIVITY: markRaw(TOPIC_SENSITIVITY),
      ALERTS: markRaw(COMPANY_ALERTS)
    }
  },
  watch: {
    topicId: {
      handler: 'init',
      immediate: true
    }
  },
  methods: {
    async init() {
      const id = this.topicId
      this.topic = undefined
      this.loading = true
      try {
        const topic = await $topics.loadTopic(id)
        if (id === this.topicId) this.topic = topic
      } catch (err) {
        if (id === this.topicId) $utils.toasts.error('Failed to load this topic. Please try again.')
      } finally {
        if (id === this.topicId) this.loading = false
      }
    },
    async onSave() {
      if (this.saving || !this.topic?.changed) return
      this.saving = true
      try {
        await this.topic.save()
        this.$dispatch('save', this.topic)
      } catch (err) {
        $utils.toasts.error('Failed to save this topic. Please try again.')
      } finally {
        this.saving = false
      }
    }
  }
}
